export const TALENT_MANAGEMENT = "TALENT_MANAGEMENT";
export const LIFE_INSURANCE = "LIFE_INSURANCE";
export const PERSONAL_BRAND = "PERSONAL_BRAND";
export const PROMOTING_TALENT_PEOPLE_ANALYTICS =
  "PROMOTING_TALENT_PEOPLE_ANALYTICS";
